<template>
  <div class="toast" v-if="data" @click.stop>
    <div class="close iconfont icon-cha" @click="bindClose"></div>
    <div class="title">{{ data.p_title }}</div>
    <div class="methods-text">产品用法</div>
    <div class="methods-list">
      <div
        class="methods-item"
        :class="{ 'methods-item-active': active === index }"
        v-for="(item, index) in data.usage"
        :key="index"
      >
        <div class="m-item-inline" @click="bindClickItem(index)">
          <div class="item-left">{{ item.title }}</div>
          <div class="item-right"
            >{{ item.every_times_num }}{{ data.min_unit_txt }}/次·{{
              item.daily_times
            }}次/日</div
          >
        </div>
      </div>
    </div>
    <div class="add-btn" @click="bindAdd($event)"
      ><span class="iconfont icon-jiahao"></span><span>加入计划</span></div
    >
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  components: {},
  data() {
    return {
      active: 0
    }
  },
  watch: {
    data() {
      this.active = 0
    }
  },
  created() {},
  methods: {
    bindClose() {
      this.$emit('close')
    },
    bindAdd(event) {
      if (this.active === undefined) {
        return
      }
      this.$emit('add', this.data, this.active, event)
    },
    bindClickItem(index) {
      this.active = index
    }
  }
}
</script>
<style lang="scss" scoped>
.toast {
  color: rgba(0, 0, 0, 0.8);
  width: 269px;
  background-color: #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  border-radius: 8px;
  transform: translate(-50%, -50%);
  padding: 20px;
  box-sizing: border-box;

  .close {
    position: absolute;
    left: 50%;
    bottom: -50px;
    transform: translate(-50%, 0%);
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1px solid #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }

  .title {
    margin-bottom: 20px;
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: bold;
    line-height: 22px;
  }

  .methods-text {
    font-size: 12px;
    font-family: PingFangSC, PingFang SC;
    font-weight: bold;
    line-height: 17px;
    margin-bottom: 8px;
  }

  .methods-list {
    margin-bottom: 40px;

    .methods-item {
      margin-bottom: 10px;

      .m-item-inline {
        max-width: 100%;
        font-size: 11px;
        font-family: PingFangSC, PingFang SC;
        line-height: 16px;
        display: inline-flex;
        align-items: center;
        border: 1px solid #cccccc;
        border-radius: 4px;
      }

      .item-left {
        padding: 7px 8px;
        border-right: 1px solid #ccc;
      }

      .item-right {
        white-space: nowrap;
        padding: 7px 8px;
      }
    }

    .methods-item:last-child {
      margin-bottom: 0;
    }

    .methods-item-active {
      color: #00cddf;

      .m-item-inline {
        border: 1px solid #03d4e6;
      }

      .item-left {
        border-right: 1px solid #03d4e6;
      }
    }
  }

  .add-btn {
    height: 31px;
    background: #03d4e6;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-family: PingFangSC, PingFang SC;
    font-weight: bold;
    color: #ffffff;
    .iconfont {
      margin-right: 4px;
      font-size: 14px;
    }
  }
}
</style>
